import eventBus from '@/helpers/eventBus';

const baseURL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  methods: {
    // Subir Archivo PDF
    async mixSubirArchivo(datosArchivo) {
      const dataForm = new FormData();
      dataForm.append('custom_name', datosArchivo.nombre);
      dataForm.append('custom_path', datosArchivo.path);
      dataForm.append('anexo', datosArchivo.archivo ? datosArchivo.archivo : document.getElementById('anexo').files[0]);

      return this.axios
        .post(baseURL, dataForm, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progreso = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        })
        .then(({ data }) => {
          const archivo = data;
          eventBus.$emit('seCargoArchivo', archivo);
          return {
            ...archivo,
          };
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
    },
  },
};
